import { render, staticRenderFns } from "./FintechBlock.vue?vue&type=template&id=3fe611e7&scoped=true&"
import script from "./FintechBlock.vue?vue&type=script&lang=js&"
export * from "./FintechBlock.vue?vue&type=script&lang=js&"
import style0 from "./FintechBlock.vue?vue&type=style&index=0&id=3fe611e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe611e7",
  null
  
)

export default component.exports